import React from "react";
import { Redirect, useLocation } from "react-router";
import { genUniqueId } from "../utils";

export default function NewHumanRedirect() {
  const location = useLocation();
  return (
    <Redirect
      to={{ pathname: `/h/new/${genUniqueId()}`, state: location.state }}
    />
  );
}
